import Model, { attr, belongsTo } from '@ember-data/model';

export default class StripeSetupIntentModel extends Model {
  @belongsTo('treatable-client', { async: false, polymorphic: true, inverse: null }) client;

  @attr() clientSecret;
  @attr() stripeCustomerId;
  @attr('boolean') isTest;
  @attr('json') paymentMethodTypes;
  @attr('json') paymentMethodOptions;
  @attr('json') automaticPaymentMethods;
}
